import React, { useEffect } from "react";
import UserSelect from "../components/Settings/UserSelect";
import WeekdaySelector from "../components/Settings/WeekdaySelector";
import {
    UniButton,
    UniCol,
    UniRow,
    UniForm,
    IntlMessageValue,
    UniSpinner,
    IntlMessage
} from "../../../../@WUM/core/Elements";
import Worktime from "../components/Settings/WorkTime";
import { setNavi } from "../../../../@WUM/core/Function";
import AllowFlexitime from "../components/Settings/AllowFlexitime";
import UniChecks from "../../../../@WUM/core/Elements/Form/Elements/Check";
import ForceBreak from "../components/Settings/ForceBreak";
import { ResponseSettings } from "../../API/response/settingstimetracking";
import { useGeneralSettings } from "./hooks/useGeneralSettings";
import {useToast} from "../../../../@WUM/core/WebsocketNotification/ToastProvider/ToastProvider";
import {TimetrackingInterface} from "./Interfaces/Timetracking.Interface";

export function GeneralSettings({
                                    onChangeUnsaved,
                                    userMode = false,
                                    userId,
                                }: TimetrackingInterface) {

    const { showToast } = useToast();

    const response = ResponseSettings(userId);
    const {
        settings, validated,
        handlers: { handleUserChange, handleFlexitime, handleForceBreak, handleSwitchChange, handleWorkdayChange },
        handleSubmit,
    } = useGeneralSettings({ response, onChangeUnsaved, showToast, userMode, userId });

    if (response === undefined || !settings) return <><UniSpinner /></>;

    return (
        <UniForm validated={validated} Submit={handleSubmit} className="p-4 worktime-settings">
            <div className={"border border-light-subtle rounded p-2 my-2 mt-0"}>
                <p className={"mb-0 text-justify"}>
                    {IntlMessage({locale: 'de', messageId: 'time.settings.general-legal-1', Store: '', renderAsHTML: true})}
                </p>
            </div>
            <input name={"id"} hidden={true} defaultValue={settings?.id} />

            {userMode === false && (
                <UniRow>
                    <UniCol lg={6}>
                        <UserSelect name="personal-admin" value={settings?.personalAdmins || null} onChange={handleUserChange} />
                    </UniCol>
                    <UniCol lg={6}>
                        <UserSelect name="personal-delegate" value={settings?.personalDelegates || null} onChange={handleUserChange} />
                    </UniCol>
                </UniRow>
            )}

            {userMode === true && (
                <div className={"border border-light-subtle rounded p-2 my-2 mt-0"}>
                    <IntlMessage messageId={"time.settings.user.general.individual"} Store={""} renderAsHTML={true} />
                </div>
            )}

            <UniRow>
                <UniCol lg={6}>
                    <WeekdaySelector value={settings.workingDays ?? []} onChange={handleWorkdayChange} name="working_days" />
                    <Worktime value={settings} />
                </UniCol>
                <UniCol>
                    <div className={"border border-light-subtle rounded p-2 my-2 mt-0"}>
                        <p className={"text-justify"}>
                            {IntlMessage({locale: 'de', messageId: 'time.settings.general-legal-2', Store: ''})}
                        </p>
                        <p className={"text-justify"}>
                            {IntlMessage({locale: 'de', messageId: 'time.settings.general-legal-3', Store: ''})}
                        </p>
                        <p className={"text-justify mb-0"}>
                            {IntlMessage({locale: 'de', messageId: 'time.settings.general-legal-4', Store: ''})}
                        </p>
                    </div>
                </UniCol>
            </UniRow>

            <AllowFlexitime value={settings} onChange={handleFlexitime}/>
            <ForceBreak value={settings} onChange={handleForceBreak}/>

            <div>
                <UniChecks
                    id="allow-worktime-interruption"
                    type="switch"
                    label={IntlMessageValue("", "time.settings.allow-worktime-interruption", "")}
                    name="allow-worktime-interruption"
                    checked={settings?.allowWorkTimeInterruption}
                    class="uni-switch ps-0 my-3"
                    onChange={handleSwitchChange}
                    info={{ text: "time.settings.allow-worktime-interruption.helper" }}
                />
            </div>

            <UniButton type="submit" class="float-end">Speichern</UniButton>
        </UniForm>

    );
};

export default GeneralSettings;
